import React, { useState, useContext, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import calenderImg from 'assets/imgs/calender.svg';
import arrowImg from 'assets/imgs/arrowDown.svg';
import radioSelect from 'assets/imgs/radio-select.svg';
import radioSelected from 'assets/imgs/radio-select-clicked.svg';
import ErrorMessage from 'shared/components/ErrorMessage';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTwZipCode, cities, districts } from 'shared/utils/ZipCode';
import { AuthContext } from 'shared/context/auth-context';
import { useHttpClient } from 'shared/hooks/http-hook';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import zhTW from 'date-fns/locale/zh-TW';
import { addDays } from 'date-fns';
import LoadingSpinner from 'shared/components/LoadingSpinner';
import { onClickLineAuth } from 'shared/utils/lineAuth';
import TermsAndPrivacy from 'components/Layout/TermsAndPrivacy';
import { modalTypeEnum } from 'components/Layout/Footer';

const StyledFormDiv = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  max-width: 70rem;
  padding: 0 1.6rem;
  margin: auto;
  justify-content: between;
  *:not(.error-message) {
    margin: 0;
    padding: 0;
    background: transparent;
  }

  .reservation-form {
  }
  .title {
    display: flex;
    padding: 4.4rem 0 2.8rem 0;
    justify-content: space-between;
    align-items: center;
  }
  .title-text {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #ffffff;
  }

  .btn-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1.6rem 0;
  }

  li {
    padding: 1.6rem 0;
  }

  .btn-line {
    width: 48%;
    height: 4.8rem;
    background: #07c203;
    mix-blend-mode: normal;
    border-radius: 8px;
    display: inline-block;
    align-items: center;
    justify-content: center;
    border: none;
  }

  .line-logo {
  }

  .btn-text {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }

  .btn-login {
    width: 48%;
    height: 4.8rem;
    border: 2px solid #ffffff;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover {
      background-color: #cd0715;
    }
  }
  .member-join {
    display: flex;
    padding: 1.6rem 0 1.2rem 0;
  }

  .checkbox-join {
    width: 2rem;
    height: 2rem;
    /* background: #ffffff; */
    border-radius: 3px;
    user-select: none;
    :checked {
      accent-color: black;
    }
  }

  .join-text {
    display: inline-block;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }

  .sub-form {
    width: 100%;
  }

  .form-element {
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
    width: 100%;
  }

  .address {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  .element-title {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    padding: 0.4rem 0;
  }

  .padding-top-12 {
    padding-top: 1.2rem;
  }

  .padding-top-24 {
    padding-top: 2.4rem;
  }

  // Remove spin button
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid #969696;
    -webkit-text-fill-color: white;
    transition: background-color 5000s ease-in-out 0s;
  }

  .element-input,
  .element-select {
    width: 100%;
    padding: 0 1.6rem;
    background: #010001;
    height: 4.8rem;
    border: 1px solid #969696;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: white;

    ::placeholder {
      color: #969696;
    }

    :focus {
      outline: none;
    }
  }

  .element-select {
    width: 100%;
    padding: 0 1.6rem;
    background: #010001;
    height: 4.8rem;
    border: 1px solid #969696;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: white;

    appearance: none;
    background-image: url(${arrowImg});
    background-repeat: no-repeat;
    background-position:
      right 1.6em top 50%,
      0 0;
    background-size:
      1.4em auto,
      100%;
  }

  .element-option {
    width: 100%;
    padding: 0 1.6rem;
    background: #010001;
    height: 4.8rem;
    border: 1px solid #969696;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: white;
  }

  .react-datepicker-wrapper,
  .react-datepicker__day,
  .react-datepicker__input-container,
  .react-datepicker__input-container input {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    color: #ffffff;
    font-size: 1.6rem;
    > input {
      width: 100%;
      padding-left: 1.6rem;
      border: 1px solid #969696;
      border-radius: 8px;
      height: 4.8rem;
      background: url(${calenderImg}) no-repeat right 1.6rem top 50%;
      :hover {
        cursor: pointer;
        svg > path {
          stroke: white;
        }
      }
      :focus {
        outline: none;
      }
    }
  }

  .react-datepicker {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    color: #ffffff;
    font-size: 1.6rem;
    margin-top: 0.3rem;
    margin-left: 3.2rem;
    border: none;

    .react-datepicker__navigation {
      padding-top: 0.9rem;
      margin: 0.8rem;
    }

    .react-datepicker__month-container {
      background-color: #1c1c1c;
      border: 1px solid #969696;
      border-radius: 8px;
      padding-bottom: 0.8rem;
    }
    .react-datepicker__month {
      margin-top: 0.8rem;
    }
    .react-datepicker__current-month {
      font-family: 'Albert Sans';
      font-style: normal;
      font-weight: 400;
      color: #ffffff;
      font-size: 1.6rem;
      height: 3.2rem;
      padding-top: 0.5rem;
      margin-top: 0.8rem;
      margin-bottom: 0.8rem;
      background-color: transparent;
    }
    .react-datepicker__triangle {
      visibility: hidden;
    }
    .react-datepicker__day-names {
      /* padding-left: 0.8rem; */
      padding: 0 1.6rem 0.8rem 1.6rem;
    }
    .react-datepicker__day-name {
      font-family: 'Albert Sans';
      font-style: normal;
      font-weight: 400;
      color: #ffffff;
      font-size: 1.6rem;
      width: 3.2rem;
    }
    .react-datepicker__day {
      width: 3.2rem;
      height: 3.2rem;
      line-height: 3.2rem;
      margin: auto;
      /* display: flex; */
      :hover {
        background-color: #cd0715;
      }
    }
    .react-datepicker__day--selected {
      background-color: #cd0715;
    }

    .react-datepicker__day--disabled {
      font-weight: 400;
      color: #969696;
      :hover {
        background-color: transparent;
      }
    }
    .react-datepicker__day--outside-month {
      visibility: hidden;
    }
  }

  .element-date {
    width: 100%;
    padding: 0 1.6rem;
    background: #010001;
    height: 4.8rem;
    border: 1px solid #969696;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: white;
    color-scheme: dark;
    -webkit-text-fill-color: white;
    ::-webkit-calendar-picker-indicator {
      background: url(${calenderImg});
      background-repeat: no-repeat;
      background-size: contain;
      padding: 0.7rem;
      cursor: pointer;
    }
    :focus {
      outline: none;
    }
  }

  .radio-form {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 0.4rem 0;
  }

  .radio-select {
    margin-left: 0.1rem;
    appearance: none;
    background: url(${radioSelect});
    width: 2rem;
    height: 2rem;
    :checked {
      background: url(${radioSelected});
    }
  }

  .radio-title {
    height: 20px;

    /* Regular 16 */

    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    display: flex;
    align-items: center;

    /* Text/ff */

    color: #ffffff;
    margin: auto 1.2rem;
    display: inline-block;
  }

  .element-select {
    color: white;
  }

  .btn-select {
    width: 120px;
    height: 40px;
    background: #1c1c1c;
    border: 0px solid #ffffff;
    border-radius: 30px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    border-color: none;
  }

  .street {
  }

  .reserve-list {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-bottom: 2px solid #262626;
    max-width: 37.4rem;
  }

  .img {
    width: 4.8rem;
    height: 4.8rem;
    object-fit: contain;
  }
  .img-name {
    width: 141px;
    height: 48px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    margin-left: 1.6rem;
  }

  .img-price {
    width: 101px;
    height: 16px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    color: #ffffff;
  }

  .btn-remove {
    width: 50px;
    height: 18px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: right;
    text-decoration-line: underline;
    color: #969696;
    border: none;
  }

  @media only screen and (min-width: 720px) {
    .sub-form {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .form-element {
      width: 32rem;
    }
    .address {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: no-wrap;
    }
    .zip-code {
      max-width: 12rem;
    }

    .title-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .btn-top {
      gap: 1.6rem;
    }

    .btn-line,
    .btn-login {
      width: 16.4rem;
      border-radius: 30px;
    }
  }
  @media only screen and (min-width: 1100px) {
    max-width: 120rem;
    justify-content: space-between;
    flex-direction: row;
    .reservation-form {
      width: 66rem;
    }
  }
`;

const StyledFooterDiv = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    margin: 3.2rem 1.6rem 1.6rem 1.6rem;
    gap: 1.6rem;
  }

  .footer-text {
    padding: 24px 16px;
    width: 100%;
    height: 100%;
    background: #1c1c1c;
    /* Regular 14 */
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    margin: auto;
    color: #ffffff;
  }

  .btn-footer {
    width: 100%;
    height: 48px;
    background: #cd0715;
    border-radius: 8px;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
    border: none;
  }

  .policy {
    background: transparent;
    text-decoration-line: underline;
    color: #969696;
  }

  @media only screen and (min-width: 1100px) {
    background: #1c1c1c;
    .wrapper {
      flex-direction: row;
      justify-content: center;

      background: #1c1c1c;
      height: 9.6rem;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      max-width: 122rem;
    }
    .footer-text {
      line-height: 44px;
      margin: auto 1.6rem;
    }
    .btn-footer {
      width: 15.6rem;
      margin: auto 3.2rem;
    }

    .wrapper {
      margin-top: 6.4rem;
    }
  }
`;

const StyledResponseDiv = styled.div`
  max-width: 66rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding-top: 2rem;
`;

const StyledAddressModal = styled(Modal)`
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  .modal-header,
  .modal-body,
  .radio-form,
  .modal-footer,
  .modal-dialog {
    background: transparent;
    border: none;
  }

  .modal-header {
    padding-top: 4rem;
  }

  .modal-title {
    margin: auto;
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    text-align: center;

    /* Text/ff */

    color: #ffffff;
    background: transparent;
  }

  .radio-form-wrapper {
    display: flex;
    flex-direction: row;
    padding: 2rem 0;
    margin: auto;
    background: #1c1c1c;
  }

  h1 {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
    padding-bottom: 1.2rem;
    background: transparent;
  }

  h2 {
    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
    background: transparent;
  }

  .modal-content {
    max-width: 48rem;
    background: #262626;
    border-radius: 16px;
    border-color: none;
  }

  .radio-form-wrapper {
    background: #1c1c1c;
    border-radius: 8px;
    margin: 2.4rem 0;
  }

  .radio-title {
    background: transparent;
  }

  .radio-select {
    margin: auto 2rem;
    padding-left: 0.1rem;
    appearance: none;
    background: url(${radioSelect});
    width: 2rem;
    height: 2rem;
    :checked {
      background: url(${radioSelected});
    }
  }

  .btn-confirm {
    width: 240px;
    height: 48px;

    /* Background/ff */

    border: 2px solid #ffffff;
    border-radius: 8px;
    background: transparent;
    margin: 0rem auto 6.4rem auto;

    font-family: 'Albert Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }

  .btn-close {
    font-size: 1.6rem;
    padding-right: 2rem;
    margin-left: 0;
  }
`;

const ReservationForm = () => {
  const today = new Date();
  const [startDate, setStartDate] = useState(addDays(today, 1));
  const reservationTime = [];
  const [includedDateTime, setIncludedDateTime] = useState({});
  const auth = useContext(AuthContext);
  const { isLoading, sendRequest } = useHttpClient();
  const [addresses, setAddresses] = useState([]);
  const [locations, setLocations] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');
  const [reservationWay, setReservationWay] = useState('store');
  // console.log(auth.reservedCars);

  const formatPhoneNumber = value => {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, '');

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you format the area code to early

    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 4)}-${phoneNumber.slice(4)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `${phoneNumber.slice(0, 4)}-${phoneNumber.slice(
      4,
      7,
    )}-${phoneNumber.slice(7, 10)}`;
  };

  for (let i = 9; i < 17; i++) {
    reservationTime.push(`${i}:00`);
  }

  const {
    city: contactCity,
    district: contactDistrict,
    zipCode: contactZipCode,
    handleCityChange: handleContactCityChange,
    handleDistrictChange: handleContactDistrictChange,
  } = useTwZipCode();

  const {
    city: reservationCity,
    district: reservationDistrict,
    zipCode: reservationZipCode,
    handleCityChange: handleReservationCityChange,
    handleDistrictChange: handleReservationDistrictChange,
  } = useTwZipCode();

  const handlePhoneNumberInput = e => {
    // this is where we'll call our future formatPhoneNumber function that we haven't written yet.
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    // we'll set the input value using our setValue
    setValue('mobile', formattedPhoneNumber, {
      shouldValidate: true,
    });
  };

  const formSchema = yup.object().shape({
    name: yup.string().when([], {
      is: () => !auth.isLoggedIn,
      then: yup.string().required('姓名為必填').max(32, '姓名最長為32字元'),
      otherwise: yup.string().notRequired(),
    }),
    company: yup.string().max(32, '公司名稱最長為32字元'),
    mobile: yup.string().when([], {
      is: () => !auth.isLoggedIn,
      then: yup
        .string()
        .required('手機號碼為必填')
        .matches(/^09\d{2}-\d{3}-\d{3}$/, '請輸入正確手機號碼'),
      otherwise: yup.string().notRequired(),
    }),
    email: yup.string().when([], {
      is: () => !auth.isLoggedIn,
      then: yup.string().required('Email為必填').email('請輸入正確Email'),
      otherwise: yup.string().notRequired(),
    }),
    password: yup.string().when([], {
      is: () => !auth.isLoggedIn,
      then: yup
        .string()
        .required('密碼為必填')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          '密碼為8到32個字元，至少各有1個大小寫英文字，一個數字，和一個特殊符號',
        )
        .max(32, '密碼最長為32個字元'),
      otherwise: yup.string().notRequired(),
    }),

    cpassword: yup.string().when([], {
      is: () => !auth.isLoggedIn,
      then: yup
        .string()
        .required('請再輸入一次密碼')
        .oneOf([yup.ref('password')], '請輸入一樣的密碼'),
      otherwise: yup.string().notRequired(),
    }),
    cCity: yup.string().matches(/^((?!請選擇).)*$/, '縣市為必填'),
    cDistrict: yup.string().matches(/^((?!請選擇).)*$/, '鄉鎮(市)區為必填'),
    rCity: yup.string().when('reservationWay', {
      is: 'scheduled',
      then: yup.string().matches(/^((?!請選擇).)*$/, '縣市為必填'),
    }),
    rDistrict: yup.string().when('reservationWay', {
      is: 'scheduled',
      then: yup.string().matches(/^((?!請選擇).)*$/, '鄉鎮(市)區為必填'),
    }),
    cStreet: yup
      .string()
      .required('門牌號碼/街道名稱為必填')
      .max(100, '地址最長為100個字元'),
    rStreet: yup.string().when('reservationWay', {
      is: 'scheduled',
      then: yup
        .string()
        .required('門牌號碼/街道名稱為必填')
        .max(100, '地址最長為100個字元'),
    }),

    rDate: yup.string().required('預約日期為必填'),
    rTime: yup.string().matches(/^((?!請選擇).)*$/, '預約時間為必填'),
    agreement: yup.bool().oneOf([true], '請勾選'),
  });

  const {
    register,
    control,
    trigger,
    setValue,
    getValues,
    formState: { errors },
    handleSubmit,
  } = useForm({ resolver: yupResolver(formSchema) });

  const [showAddress, setShowAddress] = useState(false);
  const handleAddressClose = () => setShowAddress(false);
  const handleAddressShow = () => setShowAddress(true);

  const [showLocation, setShowLocation] = useState(false);
  const handleLocationClose = () => setShowLocation(false);
  const handleLocationShow = () => setShowLocation(true);
  const [bufferedAddress, setBufferedAddress] = useState(
    addresses.length === 0 ? {} : addresses[0],
  );
  const [bufferedLocation, setBufferedLocation] = useState(
    locations.length === 0 ? {} : locations[0],
  );
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setValue('rDate', startDate.toISOString().split('T')[0]);
    setValue('reservationWay', 'store');
  }, [setValue, startDate]);

  useEffect(() => {
    const fetchOccupiedTime = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + '/reservation/occupied',
          'GET',
        );
        // Generate available time

        // Generate available date from the array
        let includedDateTimeTmp = {};
        for (let i = 1; i < 15; i++) {
          // Note: small array should be faster than Set
          const date = new Date();
          includedDateTimeTmp[
            addDays(new Date(date.toISOString().split('T')[0]), i)
          ] = [
            '09:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
          ];
        }

        // eslint-disable-next-line array-callback-return
        responseData.map(item => {
          const date = new Date(item.reservation_date);
          const time = item.reservation_time.slice(0, -3);
          // console.log("time", time);
          includedDateTimeTmp[date] = includedDateTimeTmp[date].filter(
            item => item !== time,
          );
        });

        // Remove the key from the object if the value is empty
        for (let key in includedDateTimeTmp) {
          if (includedDateTimeTmp[key].length === 0) {
            delete includedDateTimeTmp[key];
          }
        }
        setIncludedDateTime(includedDateTimeTmp);
      } catch (err) {}
    };

    const fetchAddresses = async () => {
      try {
        if (auth.isLoggedIn) {
          const responseData = await sendRequest(
            process.env.REACT_APP_BACKEND_URL + '/addresses',
            'GET',
            null,
            {
              Authorization: 'Bearer ' + auth.token,
            },
          );
          const initAddressItems = responseData
            .filter(function (address) {
              return address.type === 0;
            })
            .map(
              ({
                id,
                name,
                company,
                mobile,
                email,
                zipcode,
                city,
                district,
                street,
              }) => ({
                id,
                name,
                company,
                mobile,
                email,
                zipCode: zipcode,
                city,
                district,
                street,
              }),
            );
          setAddresses(initAddressItems);
          if (initAddressItems.length > 0) {
            setBufferedAddress(initAddressItems[0]);
          }
          var initLocationItems = responseData
            .filter(function (address) {
              return address.type === 1;
            })
            .map(
              ({
                id,
                name,
                company,
                mobile,
                email,
                zipcode,
                city,
                district,
                street,
              }) => ({
                id,
                name,
                company,
                mobile,
                email,
                zipCode: zipcode,
                city,
                district,
                street,
              }),
            );
          setLocations(initLocationItems);
          if (initLocationItems.length > 0) {
            setBufferedLocation(initLocationItems[0]);
          }
        }
      } catch (err) {}
    };
    setResponseMessage('');
    fetchOccupiedTime();
    fetchAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async data => {
    try {
      if (!auth.isLoggedIn) {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + '/reservation/new/register/login',
          'POST',
          JSON.stringify({
            name: data.name,
            password: data.password,
            email: data.email,
            mobile: data.mobile,
            company: data.company,
            cCity: data.cCity,
            cDistrict: data.cDistrict,
            cStreet: data.cStreet,
            cZipCode: contactZipCode,
            rCity: !!data.rCity ? data.rCity : '',
            rDistrict: !!data.rDistrict ? data.rDistrict : '',
            rStreet: !!data.rStreet ? data.rStreet : '',
            rZipCode: !!reservationZipCode ? reservationZipCode : 0,
            rDate: data.rDate,
            rTime: data.rTime,
            reservationWay: data.reservationWay,
            reservedCars: !!auth.reservedCars
              ? auth.reservedCars.map(car => car.id)
              : [],
          }),
          {
            'Content-Type': 'application/json',
          },
        );
        auth.clearReservedCar();
        auth.login(responseData.id, responseData.token);
        navigate('/member/reservation');
      } else {
        try {
          await sendRequest(
            process.env.REACT_APP_BACKEND_URL + '/reservation/new',
            'POST',
            JSON.stringify({
              cCity: data.cCity,
              cDistrict: data.cDistrict,
              cStreet: data.cStreet,
              cZipCode: contactZipCode,
              rCity: !!data.rCity ? data.rCity : '',
              rDistrict: !!data.rDistrict ? data.rDistrict : '',
              rStreet: !!data.rStreet ? data.rStreet : '',
              rZipCode: !!reservationZipCode ? reservationZipCode : 0,
              rDate: data.rDate,
              rTime: data.rTime,
              reservationWay: data.reservationWay,
              reservedCars: !!auth.reservedCars
                ? auth.reservedCars.map(car => car.id)
                : [],
            }),
            {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + auth.token,
            },
          );
          auth.clearReservedCar();
          navigate('/member/reservation');
        } catch (err) {
          setResponseMessage('對不起，該時段剛被預約，請預約其他時段。');
        }
      }
    } catch (err) {
      setResponseMessage('對不起，該時段剛被預約，請預約其他時段。');
    }
  };

  return (
    <React.Fragment>
      {isLoading && <LoadingSpinner asOverlay />}
      <StyledFormDiv>
        <form className="reservation-form" onSubmit={handleSubmit(onSubmit)}>
          {!auth.isLoggedIn && (
            <React.Fragment>
              <div className="title-top">
                <div className="title">
                  <h1 className="title-text">聯絡資訊</h1>
                </div>
                <div className="btn-top">
                  <button
                    className="btn-line"
                    type="button"
                    onClick={onClickLineAuth}
                  >
                    <span className="line-logo">
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5 0C16.0138 0 20.5 3.64 20.5 8.115C20.5 9.90625 19.8062 11.5188 18.3563 13.1075C16.2587 15.5225 11.5675 18.4637 10.5 18.9137C9.4625 19.3512 9.5825 18.6675 9.63 18.3975L9.63375 18.375L9.77625 17.5188C9.81 17.2638 9.845 16.8675 9.74375 16.615C9.63125 16.3363 9.18875 16.1912 8.86375 16.1213C4.0575 15.4875 0.5 12.1263 0.5 8.115C0.5 3.64 4.9875 0 10.5 0ZM6.7775 9.6075H4.87125V6.1475C4.87125 6.096 4.85088 6.04659 4.81458 6.01005C4.77828 5.97352 4.729 5.95283 4.6775 5.9525H3.975C3.94939 5.9525 3.92404 5.95754 3.90038 5.96734C3.87672 5.97714 3.85522 5.99151 3.83711 6.00961C3.81901 6.02772 3.80464 6.04922 3.79484 6.07288C3.78504 6.09653 3.78 6.12189 3.78 6.1475V10.505C3.78 10.5563 3.80125 10.605 3.835 10.6388V10.64L3.8375 10.6425L3.84 10.645C3.87625 10.6799 3.92471 10.6992 3.975 10.6987H6.7775C6.885 10.6987 6.97125 10.6112 6.97125 10.5037V9.80375C6.97141 9.77814 6.96653 9.75275 6.95689 9.72903C6.94724 9.70531 6.93301 9.68372 6.91502 9.6655C6.89703 9.64727 6.87562 9.63277 6.85203 9.62282C6.82843 9.61287 6.80311 9.60766 6.7775 9.6075ZM7.76625 5.9525C7.71453 5.9525 7.66493 5.97304 7.62836 6.00961C7.59179 6.04618 7.57125 6.09578 7.57125 6.1475V10.505C7.57125 10.6125 7.65875 10.6987 7.76625 10.6987H8.46875C8.57625 10.6987 8.6625 10.6112 8.6625 10.505V6.1475C8.6625 6.096 8.64213 6.04659 8.60583 6.01005C8.56953 5.97352 8.52025 5.95283 8.46875 5.9525H7.76625ZM12.595 5.9525C12.5433 5.9525 12.4937 5.97304 12.4571 6.00961C12.4205 6.04618 12.4 6.09578 12.4 6.1475V8.735L10.4037 6.04C10.3987 6.03344 10.3933 6.02718 10.3875 6.02125V6.02C10.3835 6.01562 10.3794 6.01145 10.375 6.0075L10.3713 6.00375C10.367 5.99965 10.3624 5.99589 10.3575 5.9925H10.3563L10.35 5.9875L10.3462 5.985C10.3443 5.98354 10.3422 5.98229 10.34 5.98125L10.33 5.975H10.3275L10.3238 5.9725L10.3112 5.9675L10.3062 5.965C10.3022 5.96352 10.298 5.96227 10.2937 5.96125H10.2913L10.2875 5.96L10.2762 5.9575H10.2688L10.265 5.95625H10.26L10.2575 5.955H9.54C9.4885 5.955 9.43909 5.97537 9.40255 6.01167C9.36602 6.04797 9.34533 6.09725 9.345 6.14875V10.5062C9.345 10.6137 9.4325 10.7 9.54 10.7H10.24C10.3488 10.7 10.4362 10.6125 10.4362 10.5062V7.91875L12.4362 10.6187C12.4495 10.6374 12.4661 10.6534 12.485 10.6663L12.4862 10.6675L12.4987 10.675L12.5037 10.6775C12.507 10.6794 12.5103 10.6811 12.5138 10.6825L12.5225 10.6862L12.5288 10.6887C12.5329 10.6901 12.537 10.6914 12.5413 10.6925H12.545C12.5613 10.6972 12.5781 10.6997 12.595 10.7H13.295C13.4038 10.7 13.4912 10.6125 13.4912 10.5062V6.1475C13.4912 6.09578 13.4707 6.04618 13.4341 6.00961C13.3976 5.97304 13.348 5.9525 13.2963 5.9525H12.595ZM17.3638 6.84875V6.14875C17.3639 6.12314 17.359 6.09775 17.3494 6.07403C17.3397 6.05031 17.3255 6.02872 17.3075 6.0105C17.2895 5.99227 17.2681 5.97777 17.2445 5.96782C17.2209 5.95787 17.1956 5.95266 17.17 5.9525H14.3675C14.3171 5.95256 14.2686 5.97229 14.2325 6.0075H14.2312L14.23 6.01L14.2275 6.01375C14.1926 6.04956 14.1729 6.09749 14.1725 6.1475V10.505C14.1725 10.5563 14.1938 10.605 14.2275 10.6388L14.23 10.6425L14.2325 10.645C14.2688 10.6798 14.3172 10.699 14.3675 10.6987H17.17C17.2775 10.6987 17.3638 10.6112 17.3638 10.5037V9.80375C17.3639 9.77814 17.359 9.75275 17.3494 9.72903C17.3397 9.70531 17.3255 9.68372 17.3075 9.6655C17.2895 9.64727 17.2681 9.63277 17.2445 9.62282C17.2209 9.61287 17.1956 9.60766 17.17 9.6075H15.2625V8.87125H17.1688C17.2763 8.87125 17.3625 8.78375 17.3625 8.67625V7.97625C17.3627 7.95064 17.3578 7.92525 17.3481 7.90153C17.3385 7.87781 17.3243 7.85622 17.3063 7.838C17.2883 7.81977 17.2669 7.80527 17.2433 7.79532C17.2197 7.78537 17.1944 7.78016 17.1688 7.78H15.2625V7.04375H17.1688C17.2763 7.04375 17.3625 6.95625 17.3625 6.84875H17.3638Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <span className="btn-text">&nbsp; 使用LINE登入</span>
                  </button>
                  <Link to="/member/login" className="btn-login" type="button">
                    會員登入
                  </Link>
                </div>
              </div>
              <div className="member-join">
                <input
                  className="checkbox-join"
                  type="checkbox"
                  id="agreement"
                  name="agreement"
                  {...register('agreement')}
                />
                <p className="join-text">&nbsp; 我同意加入車咖會員</p>
                <div>
                  {errors.agreement && (
                    <ErrorMessage message={errors.agreement.message} />
                  )}
                </div>
              </div>
              <ul className="sub-form">
                <li className="form-element">
                  <h3 className="element-title">姓名</h3>
                  <input
                    className="element-input"
                    type="text"
                    placeholder="請輸入"
                    {...register('name')}
                  />
                  {errors.name && (
                    <ErrorMessage message={errors.name.message} />
                  )}
                </li>
                <li className="form-element">
                  <h3 className="element-title">公司名稱 (選填)</h3>
                  <input
                    className="element-input"
                    type="text"
                    placeholder="請輸入"
                    {...register('company')}
                  />
                  {errors.company && (
                    <ErrorMessage message={errors.company.message} />
                  )}
                </li>
                <li className="form-element">
                  <h3 className="element-title">Email</h3>
                  <input
                    className="element-input"
                    type="email"
                    autoComplete="on"
                    placeholder="請輸入"
                    {...register('email')}
                    aria-invalid={errors.email ? 'true' : 'false'}
                  />
                  {errors.email && (
                    <ErrorMessage message={errors.email.message} />
                  )}
                </li>
                <li className="form-element">
                  <h3 className="element-title">手機號碼</h3>
                  <input
                    className="element-input"
                    placeholder="請輸入"
                    autoComplete="on"
                    {...register('mobile')}
                    onChange={e => handlePhoneNumberInput(e)}
                  />
                  {errors.mobile && (
                    <ErrorMessage message={errors.mobile.message} />
                  )}
                </li>
                <li className="form-element">
                  <h3 className="element-title">密碼</h3>
                  <input
                    className="element-input"
                    type="password"
                    autoComplete="on"
                    placeholder="請輸入"
                    {...register('password')}
                  />
                  {errors.password && (
                    <ErrorMessage message={errors.password.message} />
                  )}
                </li>
                <li className="form-element">
                  <h3 className="element-title">再次確認密碼</h3>
                  <input
                    className="element-input"
                    type="password"
                    autoComplete="on"
                    placeholder="請輸入"
                    {...register('cpassword')}
                  />
                  {errors.cpassword && (
                    <ErrorMessage message={errors.cpassword.message} />
                  )}
                </li>
              </ul>
            </React.Fragment>
          )}
          <div className="title">
            <h1 className="title-text">聯絡地址</h1>
            {auth.isLoggedIn && (
              <button
                className="btn-select"
                type="button"
                onClick={() => handleAddressShow(true)}
              >
                選擇聯絡地址
              </button>
            )}
          </div>
          <ul className="sub-form">
            <li className="form-element">
              <h3 className="element-title">縣市</h3>
              <Controller
                defaultValue="請選擇"
                control={control}
                name="cCity"
                render={({ field }) => (
                  <React.Fragment>
                    <select
                      className="element-select"
                      {...field}
                      onChange={e => {
                        handleContactCityChange(e.target.value);
                        setValue('cDistrict', districts[e.target.value][0]);
                        trigger('cDistrict');
                        field.onChange(e);
                      }}
                      value={contactCity}
                    >
                      <option
                        className="element-disabled"
                        value="請選擇"
                        disabled
                      >
                        請選擇
                      </option>
                      {cities.map((city, i) => {
                        return (
                          <option className="element-option" key={i}>
                            {city}
                          </option>
                        );
                      })}
                    </select>
                    {errors.cCity && (
                      <ErrorMessage message={errors.cCity.message} />
                    )}
                  </React.Fragment>
                )}
              />
            </li>
            <li className="form-element">
              <h3 className="element-title">鄉鎮(市)區</h3>
              <Controller
                defaultValue="請選擇"
                control={control}
                name="cDistrict"
                render={({ field }) => (
                  <React.Fragment>
                    <select
                      className="element-select"
                      {...field}
                      onChange={e => {
                        handleContactDistrictChange(e.target.value);
                        field.onChange(e);
                      }}
                      value={contactDistrict}
                    >
                      <option
                        className="element-disabled"
                        value="請選擇"
                        disabled
                      >
                        請選擇
                      </option>
                      {contactCity in districts &&
                        districts[contactCity].map((district, i) => {
                          return (
                            <option className="element-option" key={i}>
                              {district}
                            </option>
                          );
                        })}
                    </select>
                    {errors.cDistrict && (
                      <ErrorMessage message={errors.cDistrict.message} />
                    )}
                  </React.Fragment>
                )}
              />
            </li>
          </ul>
          <h3 className="element-title padding-top-12">地址</h3>
          <div className="address">
            <input
              className="element-input zip-code"
              type="tel"
              placeholder="郵遞區號"
              value={contactZipCode}
              readOnly
            ></input>
            <input
              className="element-input street"
              placeholder="門牌號碼/街道名稱"
              type="text"
              {...register('cStreet')}
            />
            {errors.cStreet && (
              <ErrorMessage message={errors.cStreet.message} />
            )}
          </div>
          <div className="title">
            <h1 className="title-text">預約資訊</h1>
            {auth.isLoggedIn && (
              <button
                className="btn-select"
                type="button"
                onClick={() => handleLocationShow(true)}
              >
                選擇預定地點
              </button>
            )}
          </div>
          <div>
            <h3 className="element-title padding-top-12">賞車方式</h3>
            <div className="radio-form">
              <input
                className="radio-select"
                type="radio"
                value="scheduled"
                id="scheduled"
                {...register('reservationWay')}
                defaultChecked={getValues('reservationWay') === 'scheduled'}
                onClick={() => {
                  setReservationWay('scheduled');
                }}
              />
              <label className="radio-title">預定地點 &ensp;</label>
              <input
                className="radio-select"
                type="radio"
                value="store"
                id="store"
                {...register('reservationWay')}
                defaultChecked={getValues('reservationWay') === 'store'}
                onClick={() => {
                  setReservationWay('store');
                }}
              />
              <label className="radio-title">到店賞車</label>
            </div>
            {reservationWay === 'scheduled' && (
              <ul>
                <li>
                  <h3 className="element-title padding-top-24">縣市</h3>
                  <Controller
                    defaultValue="請選擇"
                    control={control}
                    name="rCity"
                    render={({ field }) => (
                      <React.Fragment>
                        <select
                          className="element-select"
                          {...field}
                          onChange={e => {
                            handleReservationCityChange(e.target.value);
                            setValue('rDistrict', districts[e.target.value][0]);
                            trigger('rDistrict');
                            field.onChange(e);
                          }}
                          value={reservationCity}
                        >
                          <option
                            className="element-disabled"
                            value="請選擇"
                            disabled
                          >
                            請選擇
                          </option>
                          {cities.map((city, i) => {
                            return (
                              <option className="element-option" key={i}>
                                {city}
                              </option>
                            );
                          })}
                        </select>
                        {errors.rCity && (
                          <ErrorMessage message={errors.rCity.message} />
                        )}
                      </React.Fragment>
                    )}
                  />
                </li>
                <li>
                  <h3 className="element-title padding-top-24">鄉鎮(市)區</h3>
                  <Controller
                    defaultValue="請選擇"
                    control={control}
                    name="rDistrict"
                    render={({ field }) => (
                      <React.Fragment>
                        <select
                          className="element-select"
                          {...field}
                          onChange={e => {
                            handleReservationDistrictChange(e.target.value);
                            field.onChange(e);
                          }}
                          value={reservationDistrict}
                        >
                          <option
                            className="element-disabled"
                            value="請選擇"
                            disabled
                          >
                            請選擇
                          </option>
                          {reservationCity in districts &&
                            districts[reservationCity].map((district, i) => {
                              return (
                                <option className="element-option" key={i}>
                                  {district}
                                </option>
                              );
                            })}
                        </select>
                        {errors.rDistrict && (
                          <ErrorMessage message={errors.rDistrict.message} />
                        )}
                      </React.Fragment>
                    )}
                  />
                </li>
                <li>
                  <h3 className="element-title padding-top-24">地址</h3>
                  <div className="address">
                    <input
                      className="element-input zip-code"
                      type="tel"
                      placeholder="郵遞區號"
                      value={reservationZipCode}
                      readOnly
                    />
                    <input
                      className="element-input street"
                      placeholder="門牌號碼/街道名稱"
                      type="text"
                      {...register('rStreet')}
                    />
                    {errors.rStreet && (
                      <ErrorMessage message={errors.rStreet.message} />
                    )}
                  </div>
                </li>
              </ul>
            )}
            <ul>
              <li>
                <h3 className="element-title padding-top-24">預約日期</h3>
                {/* TODO: Fix Date Range */}
                <DatePicker
                  locale={zhTW}
                  wrapperClassName="datePicker"
                  selected={startDate}
                  // minDate={addDays(testDate, 1)}
                  // maxDate={addDays(testDate, 14)}
                  onChange={date => {
                    setStartDate(date);
                    setValue('rDate', date.toISOString().split('T')[0]);
                  }}
                  // Set the included dates as the keys of the object
                  includeDates={Object.keys(includedDateTime).map(date => {
                    return new Date(date);
                  })}
                  // includeDates={includedDateTime.keys()}
                  dateFormat="yyyy/MM/dd"
                />
                {errors.rDate && (
                  <ErrorMessage message={errors.rDate.message} />
                )}
              </li>
              <li>
                <h3 className="element-title padding-top-24">預約時間</h3>
                <select
                  className="element-select"
                  defaultValue="請選擇"
                  {...register('rTime')}
                >
                  <option className="element-disabled" value="請選擇" disabled>
                    請選擇
                  </option>
                  {new Date(startDate.toISOString().split('T')[0]) in
                    includedDateTime &&
                    includedDateTime[
                      new Date(startDate.toISOString().split('T')[0])
                    ].map((time, i) => {
                      return (
                        <option className="element-option" key={i}>
                          {time}
                        </option>
                      );
                    })}
                </select>
                {errors.rTime && (
                  <ErrorMessage message={errors.rTime.message} />
                )}
              </li>
            </ul>
          </div>
        </form>
        <ul>
          <li className="title">
            <h1 className="title-text">
              {!!auth.reservedCars && auth.reservedCars.length > 0
                ? '預約賞車清單'
                : '尚無預約車輛'}{' '}
            </h1>
          </li>
          {!!auth.reservedCars &&
            auth.reservedCars.map((item, index) => (
              <li className="reserve-list" key={index}>
                <img className="img" src={item.img} alt="car" />
                <h2 className="img-name">{item.title}</h2>
                <h3 className="img-price">
                  {'NT$' +
                    (
                      parseInt(item.price.replace('萬', '').replace(',', '')) *
                      10000
                    )
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </h3>
                <button
                  className="btn-remove"
                  type="button"
                  onClick={() => {
                    auth.removeReservedCar(item.id);
                  }}
                >
                  移除
                </button>
              </li>
            ))}
        </ul>
      </StyledFormDiv>
      <StyledResponseDiv>
        {!!responseMessage && <ErrorMessage message={responseMessage} />}
      </StyledResponseDiv>
      <StyledFooterDiv>
        <div className="wrapper">
          <h3 className="footer-text">
            我們會使用你的個人資料來處理你的訂單、支援你在本網站中的使用體驗，以及用於
            <span
              className="policy"
              type="button"
              onClick={() => setShowPrivacyModal(true)}
            >
              隱私權政策
            </span>
            中說明的其他用途。
          </h3>
          <button
            className="btn-footer"
            type="button"
            onClick={handleSubmit(onSubmit)}
          >
            確認送出
          </button>
        </div>
        <TermsAndPrivacy
          show={showPrivacyModal}
          setShow={setShowPrivacyModal}
          type={modalTypeEnum.PrivacyPolicy}
        />
      </StyledFooterDiv>
      <StyledAddressModal
        show={showAddress}
        onHide={handleAddressClose}
        centered
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>選擇聯絡地址</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="radio-form">
            {addresses.map((address, i) => {
              return (
                <div className="radio-form-wrapper" key={i}>
                  <input
                    className="radio-select"
                    type="radio"
                    value={address.street} // TO modify
                    id={address.street} // TO modify
                    checked={bufferedAddress.street === address.street}
                    onChange={() => {
                      setBufferedAddress(address);
                    }}
                  />
                  <div className="radio-title">
                    <h1>{address.name}</h1>
                    <h2>{address.phone}</h2>
                    <h2>{address.email}</h2>
                    <h2>
                      {address.zipCode}
                      {address.city}
                      {address.district}
                      {address.street}
                    </h2>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-confirm"
            onClick={() => {
              handleContactCityChange(bufferedAddress.city);
              setValue('cCity', bufferedAddress.city, {
                shouldValidate: true,
              });
              handleContactDistrictChange(bufferedAddress.district);
              setValue('cDistrict', bufferedAddress.district, {
                shouldValidate: true,
              });
              setValue('cStreet', bufferedAddress.street, {
                shouldValidate: true,
              });
              handleAddressClose();
            }}
          >
            確認
          </Button>
        </Modal.Footer>
      </StyledAddressModal>
      <StyledAddressModal
        show={showLocation}
        onHide={handleLocationClose}
        centered
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>選擇預定地點</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="radio-form">
            {locations.map((location, i) => {
              return (
                <div className="radio-form-wrapper" key={i}>
                  <input
                    className="radio-select"
                    type="radio"
                    value={location.street} // TO modify
                    id={location.street} // TO modify
                    checked={bufferedLocation.street === location.street}
                    onChange={() => {
                      setBufferedLocation(location);
                    }}
                  />
                  <div className="radio-title">
                    <h1>{location.name}</h1>
                    {/* <h2>{location.mobile}</h2> */}
                    {/* <h2>{location.email}</h2> */}
                    <h2>
                      {location.zipCode}
                      {location.city}
                      {location.district}
                      {location.street}
                    </h2>
                  </div>
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-confirm"
            onClick={() => {
              handleReservationCityChange(bufferedLocation.city);
              setValue('rCity', bufferedLocation.city, {
                shouldValidate: true,
              });
              handleReservationDistrictChange(bufferedLocation.district);
              setValue('rDistrict', bufferedLocation.district, {
                shouldValidate: true,
              });
              setValue('rStreet', bufferedLocation.street, {
                shouldValidate: true,
              });
              handleLocationClose();
            }}
          >
            確認
          </Button>
        </Modal.Footer>
      </StyledAddressModal>
    </React.Fragment>
  );
};

export default ReservationForm;
